// extracted by mini-css-extract-plugin
export default {"notFound":"notFound_notFound__9KyMH"};